import React, { useContext, useState } from "react";

import { Alert, DialogContentText, Snackbar } from "@mui/material";

import { DEFAULT_SNACKBAR_DURATION } from "../../constants";
import ConfirmDialog from "../shared/confirm-dialog";
import { removeReportsCache } from "api/endpoints/search";
import { callOptionsHeaders } from "api/helpers";
import { SnackbarContext } from "context/snackbar-context";

interface DeleteCachedReportsDialogProps {
  docSearchQueryState: any;
  regionCode: string;
  open: boolean;
  setOpen: (newOpen: boolean) => void;
  handleDocumentSearch: () => void;
}

const DeleteCachedReportsDialog = ({
  docSearchQueryState,
  regionCode,
  open,
  setOpen,
  handleDocumentSearch,
}: DeleteCachedReportsDialogProps) => {
  const [deleteCachedReportsSnackbar, setDeleteCachedReportsSnackbar] =
    useState(false);

  const { showError } = useContext(SnackbarContext);

  const handleDeleteCache = (regionCode: string) => {
    removeReportsCache(
      { inspectionId: docSearchQueryState.docId },
      callOptionsHeaders(regionCode),
    )
      .then(() => {
        setDeleteCachedReportsSnackbar(true);
        handleDocumentSearch();
      })
      .catch((error) => {
        showError(error);
      });
  };

  return (
    <>
      <ConfirmDialog
        title="Do you really want to delete all the cached reports related to the given inspection?"
        open={open}
        cancelBtnLabel="Cancel"
        confirmBtnLabel="Delete Report(s)"
        setOpen={setOpen}
        onConfirm={() => handleDeleteCache(regionCode)}
      >
        <DialogContentText align="center" alignItems="center">
          <br />
          <p>
            Please note that once the cached reports are deleted, the customers
            can generate fresh reports based on the latest inspection data.
          </p>
        </DialogContentText>
      </ConfirmDialog>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={deleteCachedReportsSnackbar}
        autoHideDuration={DEFAULT_SNACKBAR_DURATION}
        onClose={() => setDeleteCachedReportsSnackbar(false)}
        data-testid="delete-cached-reports-toast-success"
      >
        <Alert severity="success" variant="filled">
          Successfully deleted cached report(s)
        </Alert>
      </Snackbar>
    </>
  );
};
export default DeleteCachedReportsDialog;
